<template>
  <div>
    <spinner-round :isLoading="loading"></spinner-round>
    <div v-if="program && !loading">
      <sticky class="page-header sticky-page-header page-header--new" :back-button="true">
        <span slot="left-title">Edition des documents du programme {{program.name}}</span>
      </sticky>
      <div class="columns is-gapless has-bg-light is-padding">
        <div class="column is-8 is-8-widescreen is-padding-right">
          <div class="has-bg-white is-radius-large is-border">
            <div class="tabs is-separatedUnderlined is-fullwidth is-marginless">
              <ul class="has-text-weight-medium">
                <li :class="{'is-active':panel === 'DOCS'}"><a @click="panel = 'DOCS'">Documents ({{brochure.length +
                  reservation.length + otherDocuments.length}})</a>
                </li>
                <li :class="{'is-active':panel === 'DOCS_FLUX'}" v-if="program && program.from_flux">
                  <a @click="panel = 'DOCS_FLUX'">Documents issus du flux promoteur ({{documentsFlux.length}})</a>
                </li>
              </ul>
            </div>
            <div class="has-bg-annonce is-padding-left is-padding-right" v-show="panel === 'DOCS_FLUX'">
              <div class="has-text-white is-size-6">
                <span class="icon is-medium is-size-7"><i class="fas fa-rss fa-s"></i></span>
                <i>Ces informations sont automatiquement mises à jour.</i>
              </div>
            </div>
            <form @submit.prevent.stop="submit">
              <div v-show="panel === 'DOCS'">
                <div class="columns is-multiline">
                  <div class="column is-12 is-paddingless-bottom">
                    <div class="title is-5">
                      <b class="is-uppercase">Brochure du programme</b>
                    </div>
                  </div>
                  <div class="column is-12">
                    <div class="field">
                      <label class="label">Téléchargez des documents
                        <span class="is-size-3 is-margin-left-xsmall" v-helper.right="'5wPdDg9dTyOkmewUyKySOa'">
                          <i class="fal fa-question-circle fa-xs has-text-grey"></i>
                        </span>
                      </label>
                      <upload-file @upload="val => uploadDocument(val, 'Brochure du programme')"
                                   :documents="brochure"
                                   :multiple="false"
                                   :canDrag="false"
                                   :unique="true"
                      ></upload-file>
                    </div>
                  </div>
                  <div class="column is-12 is-paddingless-bottom">
                    <div class="title is-5">
                      <b class="is-uppercase">Dossier de réservation</b>
                    </div>
                  </div>
                  <div class="column is-12">
                    <div class="field">
                      <label class="label">Téléchargez des documents
                        <span class="is-size-3 is-margin-left-xsmall" v-helper.right="'5wPdDg9dTyOkmewUyKySOa'">
                          <i class="fal fa-question-circle fa-xs has-text-grey"></i>
                        </span>
                      </label>
                      <upload-file @upload="val => uploadDocument(val, 'Dossier de réservation')"
                                   @deleteDocuments="deleteDocuments"
                                   :documents="reservation"
                                   :multiple="false"
                                   :canDrag="false"
                                   :unique="true"
                      ></upload-file>
                    </div>
                  </div>
                </div>
                <div class="columns is-multiline">
                  <div class="column is-12 is-paddingless-bottom">
                    <div class="title is-5">
                      <b class="is-uppercase">Documents</b>
                    </div>
                  </div>
                  <div class="column is-12">
                    <div class="field">
                      <label class="label">Téléchargez des documents
                        <span class="is-size-3 is-margin-left-xsmall" v-helper.right="'5wPdDg9dTyOkmewUyKySOa'">
                          <i class="fal fa-question-circle fa-xs has-text-grey"></i>
                        </span>
                      </label>
                      <upload-file @upload="uploadDocument"
                                   :documents="otherDocuments"
                                   :default-names="programDocumentsNameData"
                                   :excludes-names="excludesNames"
                                   @deleteDocuments="deleteDocuments"
                      ></upload-file>
                    </div>
                  </div>
                </div>
              </div>

              <div v-show="panel === 'DOCS_FLUX'">
                <div class="columns is-multiline">
                  <div class="column is-12 is-paddingless-bottom">
                    <div class="title is-5">
                      <b class="is-uppercase">Documents</b>
                    </div>
                  </div>
                  <div class="column is-12">
                    <div v-if="documentsFlux && documentsFlux.length" class="field">
                      <view-file-list :documents="documentsFlux" :fromFlux="true" :isArray="true"></view-file-list>
                    </div>
                    <div v-else>
                      <div>Le promoteur ne fournit pas de document pour ce programme.</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="column is-12 is-margin-top is-paddingless-left is-paddingless-rigt is-border-top columns">
                <div class="column is-6">
                  <a @click="$router.goBack(route)" class="button has-bg-white is-uppercase is-fullwidth">
                    <span>Annuler</span>
                  </a>
                </div>
                <div class="column is-6">
                  <button class="button is-success is-uppercase is-fullwidth has-text-white"
                    :class="{'is-loading':loading}"
                    type="submit"
                    :disabled="loading">
                    <span v-if="loading"><i class="fal fa-spinner-third"></i></span>
                    <span v-else>Valider</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { DefaultValues } from '@/mixins'
  import { compact, uniqBy, uniq, isNil } from 'lodash'

  export default {
    name: 'ProgramDocumentEdit',
    props: {
      selectPanel: {
        type: String,
        default: 'DOCS'
      }
    },
    data () {
      return {
        program: null,
        loading: true,
        id: this.$route.params.id,
        panel: 'DOCS',
        documents: [],
        route: this.$route
      }
    },
    mixins: [DefaultValues],
    computed: {
      brochure () {
        if (this.program.documents && this.program.documents.length) {
          return compact([
            this.program.documents
              .find(x => !isNil(x) && x.filename ? x.filename === 'Brochure du programme' : false)
          ])
        } else return []
      },
      reservation () {
        if (this.program.documents && this.program.documents.length) {
          return compact([
            this.program.documents
              .find(x => !isNil(x) && x.filename ? x.filename === 'Dossier de réservation' : false)
          ])
        } else return []
      },
      otherDocuments () {
        if (this.program.documents && this.program.documents.length) {
          return compact(
            this.program.documents
              .filter(x => {
                if (!isNil(x) && x.filename) return !['Brochure du programme', 'Dossier de réservation'].includes(x.filename)
                else return true
              })
          )
        } else return []
      },
      excludesNames () {
        if (this.program.documents && this.program.documents.length) {
          return uniq(compact(
            this.program.documents
              .map(x => x.filename)
              .concat(this.brochure ? this.brochure.filename : null)
              .concat(this.reservation ? this.reservation.filename : null)
          ))
        }
      },
      documentsFlux () {
        if (this.program && this.program.documents_flux && this.program.documents_flux.length > 0) {
          return this.program.documents_flux
        } else return []
      }
    },
    methods: {
      submit (redirect = false) {
        this.loading = true
        this.program.documents = uniqBy(compact(this.otherDocuments.concat(this.brochure, this.reservation)), x => x.path)

        let payload = Object.assign({}, this.program)

        this.$api.programService.put(this.id, payload).then(r => {
          this.loading = false
          this.$notify({
            type: 'is-success',
            text: 'Le programme a bien été mis à jour'
          })
          if (redirect) {
            this.$router.push({name: 'ProgramVue', params: {id: this.id}})
          } else {
            this.program = r.data
          }
        }).catch(() => {
          this.loading = false
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de la mise à jour du programme.'
          })
        })
      },
      getProgram () {
        this.loading = true
        this.$api.programService.getOne(this.id).then(r => {
          this.loading = false
          this.program = r.data
          this.initValues(this.program)
        }).catch(() => {
          this.loading = false
        })
      },
      uploadDocument (files, filename) {
        if (files.cropped) {
          this.program.documents.splice(files.croppedIndex, 1, files[0])
        } else {
          files.forEach((file) => {
            let _filename
            if (filename) {
              _filename = filename
            } else if (file.filename) {
              _filename = file.filename
            } else {
              _filename = 'Nouveau document'
            }
            let hostedFile = Object.assign({}, file, {filename: _filename})
            console.log(hostedFile)
            this.program.documents.push(hostedFile)
          })
        }
        console.log('this.program.documents > ', this.program.documents)
        this.submit()
      },
      initValues (program) {
        if (!Array.isArray(program.documents)) program.documents = [program.documents]
      }
    },
    created () {
      this.getProgram()
      if (this.selectPanel) {
        this.panel = this.selectPanel
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/program/ProgramDocumentEdit.vue